import { SpendTransactionFix } from "graphql/generated";
import { SnapRadioButton } from "suit";

type Step3TransactionSelectProps = {
  fixTransactions: SpendTransactionFix[];
  selectedTransaction?: SpendTransactionFix;
  setSelectedTransaction: React.Dispatch<
    React.SetStateAction<SpendTransactionFix | undefined>
  >;
};

function Step3TransactionSelect({
  fixTransactions,
  selectedTransaction,
  setSelectedTransaction,
}: Step3TransactionSelectProps) {
  return (
    <>
      <p>Select a transaction to update</p>
      {fixTransactions.map((t) => {
        return (
          <div
            key={t.id}
            className="flex border p-4 rounded-lg mt-4 cursor-pointer"
            onClick={() => {
              setSelectedTransaction(t);
            }}
          >
            <div className="flex items-center">
              <SnapRadioButton checked={selectedTransaction?.id === t.id} />
              <p>{t.description}</p>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default Step3TransactionSelect;
